import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { Link } from 'ui/links';

export const LearnMoreLink = styled(Link)`
  margin-left: ${spacing.quarter};
`;

type Props = {
  url: string;
  text: string;
  openInNewTab?: boolean;
  linkSize?: 'body2' | 'caption' | 'body1';
};

export const LabelWithLink = ({ url, text, openInNewTab = false, linkSize = 'caption' }: Props) => {
  return (
    <>
      {text}
      <LearnMoreLink
        hasOpenNewTabIcon
        href={url}
        target={openInNewTab ? '_blank' : '_self'}
        size={linkSize}
      >
        Learn More
      </LearnMoreLink>
    </>
  );
};
